import { NODE_HEIGHT, NODE_WIDTH, type NodePosition } from "./layoutGraph";

export type GraphRect = {
  left: number;
  top: number;
  right: number;
  bottom: number;
};

export function intersects(a: GraphRect, b: GraphRect): boolean {
  return (
    a.left <= b.right &&
    a.right >= b.left &&
    a.top <= b.bottom &&
    a.bottom >= b.top
  );
}

export function nodeBounds(position: NodePosition): GraphRect {
  return {
    left: position.x,
    top: position.y,
    right: position.x + NODE_WIDTH,
    bottom: position.y + NODE_HEIGHT,
  };
}

export function scrollToGraphNode(
  scroll: HTMLElement,
  canvas: HTMLElement,
  position: NodePosition
) {
  const viewport = scroll.getBoundingClientRect();
  const origin = canvas.getBoundingClientRect();
  const left = origin.left + position.x;
  const top = origin.top + position.y;
  const nearest = (start: number, size: number, min: number, max: number) =>
    start < min ? start - min : start + size > max ? start + size - max : 0;
  scroll.scrollLeft += nearest(
    left,
    NODE_WIDTH,
    viewport.left + 24,
    viewport.left + scroll.clientWidth - 24
  );
  scroll.scrollTop += nearest(
    top,
    NODE_HEIGHT,
    viewport.top + 56,
    viewport.top + scroll.clientHeight - 56
  );
}
